import React from 'react';
import { useAnimateOnView } from '../../hooks/useIntersectionObserver';
import { reasons } from '../../data/reasons';
import './WhyUsSection.css';

const WhyUsSection: React.FC = () => {
  const [ref, shouldAnimate] = useAnimateOnView();

  return (
    <section
      ref={ref}
      className={`why-us-section section-padding${shouldAnimate ? ' loaded' : ''}`}
      id="why-us"
    >
      <div className="container">
        <div className="section-header wu-header">
          <span className="wu-eyebrow">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M4 12.5 9.5 18 20 6" />
            </svg>
            Por Qué Elegirnos
          </span>
          <h2 className="section-title wu-title">
            <span>Lo que nos diferencia de otros centros</span>
          </h2>
        </div>

        <div className="wu-grid">
          {reasons.map((reason, index) => (
            <div
              key={reason.id}
              className="wu-card animate-in"
              style={{ '--delay': `${0.15 + index * 0.08}s` } as React.CSSProperties}
            >
              <div className="wu-card__icon">
                <i className={reason.icon} aria-hidden="true"></i>
              </div>
              <h3 className="wu-card__title">{reason.title}</h3>
              <p className="wu-card__desc">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
